import axios from '../axios'
import qs from 'qs';

/* 
 * 文件管理模块
 */

// 上传图片
export const upload = (data) => {
    // data = qs.stringify(data);
    return axios({
        url: '/file/upload',
        method: 'post',
        data
    })
}

// 上传文件
export const add = (data) => {
    // data = qs.stringify(data);
    return axios({
        url: '/file/add',
        method: 'post',
        data
    })
}

// 批量获取文件url
export const detail = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/file/detail',
        method: 'post',
        data
    })
}

// 批量删除文件
export const del = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/file/delete',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/file.js